import { PerfTableCol } from "./vessel-details.models";

export const cpTableCols: string[] = [
  "CP_CONTRACT_VESSEL_SPEED", 
  "CP_CONTRACT_LSF",
  "CP_CONTRACT_LSG",
  "CP_CONTRACT_IFO",
  "CP_CONTRACT_MGO"
];

export const inputTableCols: string[] = [
  "INPUT_CONTRACT_VESSEL_SPEED",
  "INPUT_CONTRACT_LSF",
  "INPUT_CONTRACT_LSG",
  "INPUT_CONTRACT_IFO",
  "INPUT_CONTRACT_MGO"
];

export const ecoTableCols: string[] = [
  "ECO_CONTRACT_VESSEL_SPEED",
  "ECO_CONTRACT_LSF",
  "ECO_CONTRACT_LSG",
  "ECO_CONTRACT_IFO",
  "ECO_CONTRACT_MGO"
];

export const ecoColumns: PerfTableCol[] = [
  { header: "Speed", accessor: "ECO_CONTRACT_VESSEL_SPEED" },
  { header: "LSF", accessor: "ECO_CONTRACT_LSF" },
  { header: "LSG", accessor: "ECO_CONTRACT_LSG" },
  { header: "IFO", accessor: "ECO_CONTRACT_IFO" },
  { header: "MGO", accessor: "ECO_CONTRACT_MGO" },
];

export const inputColumns: PerfTableCol[] = [
  { header: "Speed", accessor: "INPUT_CONTRACT_VESSEL_SPEED" },
  { header: "LSF", accessor: "INPUT_CONTRACT_LSF" },
  { header: "LSG", accessor: "INPUT_CONTRACT_LSG" },
  { header: "IFO", accessor: "INPUT_CONTRACT_IFO" },
  { header: "MGO", accessor: "INPUT_CONTRACT_MGO" },
];

export const cpColumns: PerfTableCol[] = [
  { header: "Speed", accessor: "CP_CONTRACT_VESSEL_SPEED" },
  { header: "LSF", accessor: "CP_CONTRACT_LSF" },
  { header: "LSG", accessor: "CP_CONTRACT_LSG" },
  { header: "IFO", accessor: "CP_CONTRACT_IFO" },
  { header: "MGO", accessor: "CP_CONTRACT_MGO" },
];